import Content from "uxp-documentation/src/pages/uxp-api/reference-js/Modules/uxp/Entry Points/UxpCommandInfo";
import * as React from 'react';
export default {
  Content,
  React
};